import React from 'react';
import Track from './Track';

const TrackedA = ({ ...props }) => {
    return <Track innerAs="a" {...props} />;
};

export default TrackedA;
